import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { motion } from 'framer-motion';

function Conferences() {
    // Conference data with images from public directory
    const conferences = [
        {
            id: 1,
            title: 'Google Summer of Code Mentor Summit 2025',
            location: 'Munich, Germany',
            date: 'Oct 2025',
            imageUrl: '/3.png',
            description: 'Attended the GSoC Mentor annual Tech Summit focusing on emerging technologies, AI advancements, and cloud computing solutions. Participated in workshops on Open Source Software(OSS) development and modern OSS practices.'
        },
    ];

    // Function to render individual conference entry
    const renderConference = (conference) => (
        <div key={conference.id} className="p-4">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
                <img
                    className="object-cover w-full h-48 rounded-t-lg"
                    src={conference.imageUrl}
                    alt={conference.title}
                    onError={(e) => {
                        // Fallback to a placeholder if image fails to load
                        e.target.src = 'https://via.placeholder.com/400x300?text=Conference';
                    }}
                />
                <div className="p-6">
                    <div className="mb-2">
                        <h3 className="text-xl font-semibold text-gray-800 dark:text-gray-200">
                            {conference.title}
                        </h3>
                        <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                            {conference.location} • {conference.date}
                        </p>
                    </div>
                    <p className="mt-3 text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
                        {conference.description}
                    </p>
                </div>
            </div>
        </div>
    );

    // Settings for react-multi-carousel
    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 1024 },
            items: 3,
        },
        desktop: {
            breakpoint: { max: 1024, min: 768 },
            items: 2,
        },
        tablet: {
            breakpoint: { max: 768, min: 464 },
            items: 1,
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
        },
    };

    return (
        <section className="bg-white dark:bg-gray-900" id="conferences">
            <div className="container px-6 py-10 mx-auto">
                <motion.h1
                    className="text-2xl font-semibold text-center capitalize lg:text-3xl text-gray-800 dark:text-white mb-8"
                    initial={{ opacity: 0, y: -50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                >
                    Conferences Attended
                </motion.h1>
                <Carousel responsive={responsive}>
                    {conferences.map((conference) => renderConference(conference))}
                </Carousel>
            </div>
        </section>
    );
}

export default Conferences;

